import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import { FadeUp } from "@/components/landing/Reveal";
import { LEGAL } from "@/pages/legalContent";

export default function LegalPage({ page }) {
  const doc = LEGAL[page];

  useEffect(() => {
    if (window.lenis) window.lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <div data-testid={`legal-page-${page}`} className="min-h-screen bg-cream">
      <Seo
        title={`${doc.title} | شيادن الأصول العقارية`}
        siteName="شيادن الأصول العقارية"
        description={doc.intro}
      />

      <header className="bg-navy">
        <div className="mx-auto flex h-[72px] max-w-4xl items-center justify-between px-5 md:px-8">
          <Link to="/" data-testid="legal-brand-link" className="leading-none">
            <span className="font-display text-xl font-bold tracking-[0.18em] text-cream">
              SHIYADN
            </span>
            <span className="mt-1 block font-head text-[11px] font-semibold text-copper">
              شيادن الأصول العقارية
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home-link"
            className="group inline-flex items-center gap-2 rounded-full border border-cream/30 px-5 py-2.5 font-head text-sm font-bold text-cream transition-colors duration-300 hover:border-copper hover:text-copper"
          >
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            العودة للرئيسية
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-5 py-16 md:px-8 md:py-24">
        <FadeUp>
          <span className="font-display text-xs tracking-[0.35em] text-petrol">{doc.eyebrow}</span>
        </FadeUp>
        <FadeUp delay={0.1}>
          <h1
            data-testid="legal-title"
            className="mt-4 font-head text-4xl font-extrabold text-navy sm:text-5xl"
          >
            {doc.title}
          </h1>
        </FadeUp>
        <FadeUp delay={0.18}>
          <p className="mt-4 text-xs text-ink/40">{doc.updated}</p>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink/70">{doc.intro}</p>
        </FadeUp>

        <div className="mt-14 space-y-10">
          {doc.sections.map((s, i) => (
            <FadeUp key={s.heading} delay={0.05 * i}>
              <section
                data-testid={`legal-section-${i + 1}`}
                className="border-t border-ink/10 pt-8"
              >
                <h2 className="font-head text-xl font-bold text-navy md:text-2xl">{s.heading}</h2>
                {s.paragraphs.map((p, j) => (
                  <p key={j} className="mt-4 text-sm leading-loose text-ink/65 md:text-base">
                    {p}
                  </p>
                ))}
              </section>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.15}>
          <p className="mt-16 border border-dashed border-ink/20 p-5 text-xs leading-relaxed text-ink/45">
            ملاحظة: هذه الصفحة صياغة أولية لأغراض النشر المبدئي، ويُنصح بمراجعتها
            واعتمادها من مستشار قانوني قبل الاعتماد النهائي.
          </p>
        </FadeUp>
      </main>
    </div>
  );
}
